import React, { ReactNode } from 'react';

type ListInfoItemProps = {
    label: ReactNode;
    value?: ReactNode;
    title?: string;
    className?: string;
    valueClassName?: string;
    indicatorClassName?: string | null;
    active?: boolean;
}

export const ListInfoItem = ({
    label,
    value,
    title,
    className = '',
    valueClassName = '',
    indicatorClassName,
    active = false,
}: ListInfoItemProps) => {
    const hasValue = value !== undefined && value !== null && value !== '';

    return (
        <div className={`py-2 px-4 min-w-[115px] h-[50px] rounded overflow-hidden transition-all ${active ? 'bg-white' : 'bg-gray-50 group-hover:bg-gray-100'} ${className}`}>
            <p className="text-gray-400 text-xs whitespace-nowrap">{label}</p>
            <p
                className={`text-sm whitespace-nowrap truncate flex items-center gap-xs ${hasValue ? 'text-gray-900' : 'text-gray-300'} ${valueClassName}`}
                title={title || (typeof value === 'string' ? value : hasValue ? undefined : 'N/A')}
            >
                {indicatorClassName && (
                    <span className={`w-[9px] h-[9px] rounded-full shrink-0 ${indicatorClassName}`}></span>
                )}
                <span className="truncate">{hasValue ? value : 'N/A'}</span>
            </p>
        </div>
    );
};

type ListRowProps = {
    title: ReactNode;
    badge?: ReactNode;
    media?: ReactNode;
    children?: ReactNode;
    actions?: ReactNode;
    selected?: boolean;
    onClick?: () => void;
    className?: string;
    contentClassName?: string;
    minHeightClassName?: string;
}

const ListRow = ({
    title,
    badge,
    media,
    children,
    actions,
    selected = false,
    onClick,
    className = '',
    contentClassName = '',
    minHeightClassName = 'min-h-[118px]',
}: ListRowProps) => (
    <div
        className={`relative group flex py-sm border transition-all gap-xl px-md cursor-pointer rounded-md ${minHeightClassName} ${
            selected
                ? 'bg-primary-25 border-primary-500 shadow-focus'
                : 'border-transparent border-b-gray-200 hover:bg-gray-50'
        } ${className}`}
        onClick={onClick}
    >
        {media}
        <div className={`flex w-full min-w-0 flex-col gap-sm justify-center ${contentClassName}`}>
            <div className="flex items-center gap-xs min-w-0">
                <h2 className="text-sm font-medium p-0 m-0 text-gray-900 truncate">
                    {title}
                </h2>
                {badge}
            </div>
            {children && (
                <div className="flex w-full justify-between gap-md">
                    <div className="flex flex-row flex-wrap gap-xs min-w-0">
                        {children}
                    </div>
                    {actions && (
                        <div className="flex gap-sm shrink-0">
                            {actions}
                        </div>
                    )}
                </div>
            )}
        </div>
    </div>
);

export default ListRow;
